<template>
    <div>
        <ul class="pagination__list">
            <li class="pagination__item prev_btn">
                <svg role="img" width="14" height="14" aria-hidden="true">
                    <use xlink:href="#svg-icon-arrow-next"></use>
                </svg>
            </li>
            <li v-for="i in pageCount" :key="i" class="pagination__item" :class="{active: pageNumber === i}" @click="goPage(i)">{{i}}</li>
            <li class="pagination__item next_btn">
                <svg role="img" width="14" height="14" aria-hidden="true">
                    <use xlink:href="#svg-icon-arrow-next"></use>
                </svg>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'pagination',
    props: {
        listData: {
            type: Array,
            required: true
        },
        size: {
            type: Number,
            required: false,
            default: 10
        },
        pageNumber: {
            type: Number,
            required: false,
            default: 1
        }
    },
    methods: {
        goPage(page) {
            this.$emit('changePage', page);
        }
    },
    computed: {
        pageCount(){
            let l = this.listData.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        
    }
}
</script>
<style scoped>
.pagination__list{
    list-style: none;
    display: inline-flex;
    margin: 3px 0;
    padding: 0;
    background-color: #fff;
    border-radius: 10px;
    color: #636363;
}
.pagination__item{
    padding: 5px 10px;
    border-right: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.pagination__item:hover{
    background-color: #2a9f54;
    color: #fff;
    transition: background-color .2s ease-in-out;
}
.next_btn{
    border: none;
}
.prev_btn svg{
    transform: rotate(-180deg);
}
.active{
    background-color: #2a9f54;
    color: #fff;
}
.prev_btn:hover{
    border-radius: 10px 0 0 10px;
}
.next_btn:hover{
    border-radius: 0 10px 10px 0;
}
</style>